import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function TermsAndPrivacy() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-primary/5 border-b border-border">
        <div className="max-w-4xl mx-auto px-4 py-12">
          <Link to="/" className="inline-flex items-center gap-2 text-primary hover:text-primary/80 mb-6">
            <ArrowLeft className="h-4 w-4" />
            Zpět na web
          </Link>
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-foreground">
            Podmínky používání a zásady ochrany osobních údajů
          </h1>
          <p className="text-lg text-foreground/75">
            Pravidla vydaná dne 2025-10-14, podle kterých Swimmie funguje.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-16">
        <div className="prose prose-lg max-w-none space-y-8 text-foreground">
          {/* Section 1 */}
          <section>
            <h2 className="text-3xl font-bold mb-6 text-foreground">1. Kdo jsme</h2>
            <div className="space-y-4 opacity-90">
              <p>
                Aplikaci Swimmie ti poskytuje společnost Swimmie by LKL, s.r.o., IČO 21884307, se sídlem Příčná 1892/4, 110 00 Praha 1, zapsaná pod spisovou značkou C 406786/MSPH u Městského soudu v Praze.
              </p>
              <p>Kontakt: info@swimmie.cz</p>
              <p>Web: https://swimmie.app</p>
              <p>Logo a název Swimmie jsou registrované ochranné známky.</p>
            </div>
          </section>

          {/* Section 2 */}
          <section>
            <h2 className="text-3xl font-bold mb-6 text-foreground">2. Kdo může Swimmie používat</h2>
            <div className="space-y-4 opacity-90">
              <p>Swimmie je určené pro plavce a milovníky vody od 16 let věku.</p>
              <p>
                Trénování s aplikací je jen pro zdravé a zkušené plavce, kteří zvládnou uplavat alespoň 750 metrů v kuse. Pokud je to nad Tvé síly, není pro tebe Swimmie tréninkový plán určený.
              </p>
              <p>
                Swimmie není lékařská služba. Pokud máš zdravotní omezení, poraď se se svým doktorem, než začneš plavat podle našich plánů.
              </p>
            </div>
          </section>

          {/* Section 3 */}
          <section>
            <h2 className="text-3xl font-bold mb-6 text-foreground">3. Vytvoření účtu a související data</h2>
            <div className="space-y-4 opacity-90">
              <p>Přihlásíš se e-mailem a heslem, nebo přes svůj Apple/Google účet.</p>
              <p>V případě přihlášení přes Apple/Google účet sbíráme pouze email.</p>
              <p>
                Při registraci dále uvedeš křestní jméno a pár údajů o tom, jak Ti plavání jde, aby Ti šel sestavit tréninkový plán.
              </p>
              <p>Tvůj účet je tvůj – nikomu jinému ho nepůjčuj.</p>
            </div>
          </section>

          {/* Section 4 */}
          <section>
            <h2 className="text-3xl font-bold mb-6 text-foreground">4. Předplatné a platby</h2>
            <div className="space-y-4 opacity-90">
              <p>
                Tréninkové plány (a některý další obsah) jsou dostupné jen po zaplacení předplatného nazvaného Swimmie Pro.
              </p>
              <ul className="list-disc list-inside space-y-2 ml-2">
                <li>Měsíční předplatné: 249 Kč/měsíc</li>
                <li>Čtvrtletní předplatné: 699 Kč za 3 měsíce</li>
              </ul>
              <p>Předplatné se automaticky obnovuje, dokud ho nezrušíš přes App Store nebo Google Play.</p>
              <p>
                Pokud Swimmie Pro nebude vhodné (např. jsi začátečník nebo profi závodník, pro které zatím plán nemáme) bez řečí předplatné zrušíme a vrátíme Ti peníze – napiš na info@swimmie.cz.
              </p>
              <p>Samotné vrácení peněz vždy proběhne pouze přes kanál, kterým sis předplatné koupil.</p>
              <p>
                Mimo předplatné si ještě můžeš objednat konzultační služby hrazené jednorázovou platbou, více o tom v kapitole 6.
              </p>
            </div>
          </section>

          {/* Section 5 */}
          <section>
            <h2 className="text-3xl font-bold mb-6 text-foreground">5. Obsah aplikace</h2>
            <div className="space-y-4 opacity-90">
              <p>Najdeš tu články, videokurzy, možnost konzultace a hlavně svůj osobní tréninkový plán.</p>
              <p>Můžeš si ukládat oblíbené články a sledovat svůj postup tréninků.</p>
              <p>
                Data o tréninku můžeš zapisovat ručně a nebo si je přenést z Apple Health/Google Fit. Více o tom v kapitole 7.
              </p>
            </div>
          </section>

          {/* Section 6 */}
          <section>
            <h2 className="text-3xl font-bold mb-6 text-foreground">6. Videokonzultace a hodnocení stylu</h2>
            <div className="space-y-4 opacity-90">
              <p>
                Můžeš si objednat videokonzultaci nebo poslat video svého plavání ke stylové analýze naším trenérem. Tyto "doplňkové služby" jsou placené zvlášť formou jednorázové platby.
              </p>
              <p>Tyto služby nemusí být dostupné v případě vysokého vytížení našich trenérů.</p>
              <p>
                V případě přetížení trenérů můžeme objednávku zrušit, uhrazenou platbu vrátit a zaslaná data smazat.
              </p>
              <p>Videa zaslaná k analýze nejsou veřejná – vidí je jen náš trenér.</p>
              <p>Vyhrazujeme si nicméně právo si je uložit a anonymně použít pro zlepšování Swimmie.</p>
              <p>
                Je přísně zakázáno tímto způsobem posílat explicitní obsah. Pokud to někdo udělá, dostane na svůj e-mail doživotní ban a jeho předplatné bude ukončeno bez nároku na vrácení dosud zaplacených peněz jak za předplatné, tak za doplňkovou službu.
              </p>
            </div>
          </section>

          {/* Section 7 */}
          <section>
            <h2 className="text-3xl font-bold mb-6 text-foreground">7. Tvoje data a soukromí</h2>
            <div className="space-y-4 opacity-90">
              <p>
                Tvoje data (tréninkové logy, zpětná vazba) používáme k tomu, aby Swimmie fungovalo a mohli jsme Ti poskytovat výše popsané služby. V anonymní podobě je můžeme použít k tomu, abychom se mohli zlepšovat.
              </p>
              <p className="font-semibold">Tréninková data z Apple Health/Google Fit:</p>
              <p>
                Data z Apple Health/Google Fit se do Swimmie přenesou pouze pokud to sám při instalaci aplikace povolíš.
              </p>
              <p>Každý přenos navíc musíš v aplikaci explicitně iniciovat.</p>
              <p>
                Do aplikace přenášíme začátek a konec tréninku, dobu trvání a uplavanou vzdálenost.
              </p>
              <p>Data se nikdy nepropisují zpět do Apple Health/Google Fit.</p>
              <p>
                Pokud si objednáš videokonzultaci nebo analýzu stylu, náš trenér může nahlédnout na Tvá dosavadní tréninková data. Bez toho by to nemělo smysl. Naši trenéři jsou samozřejmě vázáni mlčenlivostí.
              </p>
              <p>
                Některá data můžeme v anonymní podobě použít k trénování algoritmů pro zlepšování aplikace.
              </p>
              <p>
                Data můžeme sdílet s důvěryhodnými partnery, kteří nám pomáhají aplikaci Swimmie vyvíjet a provozovat (jsme trenéri, nikoliv programátoři). Nikdy je ale neprodáváme ani nesdílíme za jakýmkoliv jiným účelem, např. pro marketing.
              </p>
              <p>Žádný uživatelský obsah není nikdy veřejně sdílen.</p>
              <p>Můžeš kdykoliv požádat o smazání účtu a dat – napiš na e-mail info@swimmie.cz</p>
              <p>
                Tamtéž můžeš napsat v případě dotazů k politice ochrany dat nebo, chceš-li si svá data získat.
              </p>
              <p>
                V obou předchozích bodech, prosíme, piš ze stejného e-mailu jako je Tvůj Swimmie účet.
              </p>
              <p>Účet, který je 2 roky neaktivní, můžeme po čase smazat sami.</p>
              <p>
                Výjimkou jsou e-maily, ze kterých přišel zakázaný obsah, ty si uchováváme navždy z titulu našeho oprávněného zájmu ochrany trenérů.
              </p>
              <p>Data uchováváme v EU.</p>
            </div>
          </section>

          {/* Section 8 */}
          <section>
            <h2 className="text-3xl font-bold mb-6 text-foreground">8. Naše odpovědnost</h2>
            <div className="space-y-4 opacity-90">
              <p>Swimmie ti dává tréninkové plány a tipy, ale vždy plaveš na vlastní riziko.</p>
              <p>
                Swimmie není zdravotní služba a nenahrazuje odbornou lékařskou péči ani rady lékaře. Taky nenahrazujeme trenéra na bazénu, roztleskávačky nebo plavčíka.
              </p>
              <p>Neodpovídáme za zranění, škody nebo neúspěchy, které mohou při tréninku vzniknout.</p>
              <p>
                Ve Swimmie dodržujeme standardní "best practices" pro ochranu dat před ztrátou nebo zneužitím.
              </p>
            </div>
          </section>

          {/* Section 9 */}
          <section>
            <h2 className="text-3xl font-bold mb-6 text-foreground">9. Změna podmínek</h2>
            <div className="space-y-4 opacity-90">
              <p>Tyto podmínky můžeme jednostranně změnit.</p>
              <p>
                O změně Tě informujeme nejméně 14 dnů dopředu oznámením v aplikaci a na webu.
              </p>
              <p>
                Pokud s novými pravidly nebudeš souhlasit, můžeš na adrese info@swimmie.cz požádat o zrušení účtu, předplatného a vrácení poměrné části zaplaceného Swimmie Pro.
              </p>
            </div>
          </section>

          {/* Section 10 */}
          <section>
            <h2 className="text-3xl font-bold mb-6 text-foreground">10. Závěrem</h2>
            <div className="space-y-4 opacity-90">
              <p>Používáním Swimmie souhlasíš s těmito podmínkami.</p>
              <p>
                Pokud tato pravidla porušíš, můžeme ti ukončit předplatné, účet smazat a nebo zablokovat přístup, bez nároku na vrácení dosud zaplacených peněz.
              </p>
              <p>Řídíme se českým právem a případné spory řeší české soudy.</p>
            </div>
          </section>

          {/* Section 11 */}
          <section>
            <h2 className="text-3xl font-bold mb-6 text-foreground">11. Dodatečné podmínky pro App Store</h2>
            <p className="opacity-90 mb-6">
              Pokud jsi si aplikaci Swimmie stáhl(a) z Apple App Store, platí pro Tebe následující dodatečné podmínky:
            </p>

            <div className="space-y-6">
              <div>
                <h3 className="text-2xl font-bold mb-4 text-foreground">11.1. Smluvní vztah</h3>
                <p className="opacity-90">
                  Tyto podmínky představují smlouvu uzavřenou výhradně mezi Tebou a společností Swimmie by LKL, s.r.o. Společnost Apple Inc. není stranou této smlouvy a nenesou žádnou odpovědnost za aplikaci Swimmie nebo její obsah. Používání aplikace se řídí pravidly používání App Store uvedenými v Podmínkách služeb médií Apple (Apple Media Services Terms and Conditions).
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-4 text-foreground">11.2. Rozsah licence</h3>
                <p className="opacity-90">
                  Licence k používání aplikace Swimmie je omezena na nepřenosnou licenci k používání aplikace na zařízeních značky Apple, která vlastníš nebo ovládáš, a to v souladu s Pravidly používání stanovenými v Podmínkách služeb médií Apple. Tato licence Ti rovněž umožňuje přístup k aplikaci prostřednictvím jiných účtů spojených s nákupem přes Rodinné sdílení (Family Sharing) nebo hromadný nákup (volume purchasing).
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-4 text-foreground">11.3. Údržba a podpora</h3>
                <p className="opacity-90">
                  Společnost Swimmie by LKL, s.r.o. je výhradně odpovědná za poskytování jakýchkoli služeb údržby a podpory ve vztahu k aplikaci Swimmie, jak je uvedeno v těchto podmínkách nebo jak vyžaduje příslušný zákon. Apple nemá žádnou povinnost poskytovat jakékoli služby údržby nebo podpory ve vztahu k aplikaci Swimmie.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-4 text-foreground">11.4. Záruka</h3>
                <p className="opacity-90">
                  Společnost Swimmie by LKL, s.r.o. je výhradně odpovědná za jakékoli záruky na produkt, ať už výslovné nebo vyplývající ze zákona, v rozsahu, který není účinně vyloučen. V případě, že aplikace Swimmie nesplní jakoukoliv platnou záruku, můžeš společnost Apple informovat a Apple Ti vrátí kupní cenu za aplikaci. V maximálním rozsahu povoleném příslušným zákonem nebude mít Apple žádné další záruční povinnosti ohledně aplikace Swimmie a jakékoli další nároky, ztráty, závazky, škody, náklady nebo výdaje spojené s nesplněním záruky budou výhradní odpovědností společnosti Swimmie by LKL, s.r.o.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-4 text-foreground">11.5. Nároky týkající se produktu</h3>
                <p className="opacity-90">
                  Společnost Swimmie by LKL, s.r.o., nikoliv Apple, je odpovědná za řešení jakýchkoli nároků Tebe nebo jakékoli třetí strany týkajících se aplikace Swimmie nebo Tvého vlastnictví a/nebo používání aplikace Swimmie, včetně (i) nároků týkajících se odpovědnosti za produkt; (ii) jakéhokoli nároku, že aplikace Swimmie nesplňuje jakýkoli platný právní nebo regulační požadavek; a (iii) nároků vzniklých na základě ochrany spotřebitele, soukromí nebo podobné legislativy, včetně nároků souvisejících s použitím frameworků HealthKit a HomeKit aplikací Swimmie. Tyto podmínky neomezují naši odpovědnost vůči Tobě nad rámec toho, co povoluje příslušný zákon.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-4 text-foreground">11.6. Práva duševního vlastnictví</h3>
                <p className="opacity-90">
                  V případě jakéhokoli nároku třetí strany, že aplikace Swimmie nebo Tvé vlastnictví a používání aplikace Swimmie porušuje práva duševního vlastnictví této třetí strany, je společnost Swimmie by LKL, s.r.o., nikoliv Apple, výhradně odpovědná za vyšetřování, obhajobu, vyrovnání a ukončení jakéhokoli takového nároku na porušení práv duševního vlastnictví.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-4 text-foreground">11.7. Právní soulad</h3>
                <p className="opacity-90">
                  Prohlašuješ a zaručuješ se, že (i) se nenacházíš v zemi, která je předmětem embarga vlády Spojených států, nebo která byla vládou Spojených států označena jako země "podporující terorismus"; a (ii) nejsi uveden(a) na žádném seznamu zakázaných nebo omezených stran vlády Spojených států.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-4 text-foreground">11.8. Podmínky třetích stran</h3>
                <p className="opacity-90">
                  Při používání aplikace Swimmie musíš dodržovat veškeré příslušné podmínky třetích stran. Například pokud používáš aplikaci Swimmie s Apple Health nebo Google Fit integrací, nesmíš být v rozporu s podmínkami používání těchto služeb.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-4 text-foreground">11.9. Kontaktní informace</h3>
                <p className="opacity-90">
                  Veškeré dotazy, stížnosti nebo nároky týkající se aplikace Swimmie by měly být směrovány na adresy uvedené v sekci 1.
                </p>
              </div>

              <div>
                <h3 className="text-2xl font-bold mb-4 text-foreground">11.10. Příjemce výhod třetí strany</h3>
                <p className="opacity-90">
                  Uznáváš a souhlasíš s tím, že Apple a dceřiné společnosti Apple jsou příjemci výhod třetí strany v rámci těchto podmínek, a že po Tvém přijetí těchto podmínek bude mít Apple právo (a bude se považovat za to, že toto právo přijal) vymáhat proti Tobě tyto podmínky jako příjemce výhod třetí strany.
                </p>
              </div>
            </div>
          </section>
        </div>

        {/* Footer CTA */}
        <div className="mt-20 pt-12 border-t border-border">
          <p className="text-center text-foreground/75 mb-6">
            Máš otázky? Napiš nám na <a href="mailto:info@swimmie.cz" className="text-primary hover:underline">info@swimmie.cz</a>
          </p>
          <div className="text-center">
            <Link to="/" className="inline-flex items-center gap-2 text-primary hover:text-primary/80 font-semibold">
              <ArrowLeft className="h-4 w-4" />
              Zpět na hlavní stránku
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}